<div class="tw-pt-7 tw-border-box group-wrapper" #wrapper>
	<ng-container>
		<mat-tab-group
			class="sp-mat-tab-group"
			[disableRipple]="true"
			[disablePagination]="true"
			[@.disabled]="true"
			[(selectedIndex)]="selectedTabIndex"
			(selectedIndexChange)="onTabSelect($event)">
			<mat-tab>
				<ng-template mat-tab-label>
					<div class="tw-animate-fadein-200 tab-label-wrapper tw-text-center right-border">
						<div class="tab-label">Upcoming</div>
					</div>
				</ng-template>
				<!-- Upcoming MAT TAB CONTENT -->
				<ng-container>
					<ng-container [ngTemplateOutlet]="instancesContent" [ngTemplateOutletContext]="{ instances: upcomingInstances }"></ng-container>
				</ng-container>
				<!-- END Upcoming MAT TAB CONTENT -->
			</mat-tab>
			<mat-tab>
				<ng-template mat-tab-label>
					<div class="tw-animate-fadein-200 tab-label-wrapper tw-text-center right-border">
						<div class="tab-label">Past</div>
					</div>
				</ng-template>
				<!-- Past MAT TAB CONTENT -->
				<ng-container>
					<ng-container [ngTemplateOutlet]="instancesContent" [ngTemplateOutletContext]="{ instances: pastInstances }"></ng-container>
				</ng-container>
				<!-- END Past MAT TAB CONTENT -->
			</mat-tab>
		</mat-tab-group>
	</ng-container>

	<ng-template #instancesContent let-instances="instances">
		<div [ngStyle]="{ height: contentHeightStr }" class="tw-relative">
			<div class="sessions-button tw-pb-3" *ngIf="activity.status !== 'archived' && hideAddSession == false">
				<sp-activity-add-sessions
					[activity]="activity"
					[upcomingInstances]="upcomingInstances"
					[canManage]="sessionsEditable"></sp-activity-add-sessions>
			</div>
			<div
				*ngIf="!loading && instances.length"
				class="up-list"
				[ngClass]="{ past: selectedTabIndex === 1 }"
				[style.height]="listHeight ? listHeight : ''">
				<div
					*ngFor="let instance of instances; let index = index"
					(click)="selectInstance(instance, index)"
					(mouseenter)="indexHovered = index"
					(mouseleave)="indexHovered = -1"
					[ngClass]="{ selected: instance.selected }"
					class="tw-cursor-pointer">
					<div class="tw-flex tw-justify-between tw-w-full">
						<div>
							<div class="time-header">{{ instance.start_time | date : 'EEEE, MMMM d' }}</div>
							<div class="time">
								<span *ngIf="flexPeriod">
									{{ flexPeriod.name }} <img class="tw-py-1 tw-px-1" [src]="'./assets/Ellipse (Gray500).svg' | resolveAsset" />
								</span>
								{{ instance.start_time | date : 'h:mm a' }} - {{ instance.end_time | date : 'h:mm a' }}
							</div>
							<div class="num-attendees">
								{{ instance.current_num_attendees }}{{ activity.max_attendees > 0 ? '/' + activity.max_attendees : '' }}
								students
							</div>
						</div>
						<div class="tw-w-9">
							<img
								*ngIf="sessionsEditable && (indexHovered === index || instance.selected)"
								(click)="onOptionsClick($event, instance)"
								class="tw-cursor-pointer tw-animate-fadein-200 tw-w-5 tw-ml-auto tw-mr-2 tw-p-2 tw-rounded-full tw-cursor-pointer"
								[ngClass]="{ 'hover:tw-bg-gray-150': !instance.selected, 'hover:tw-bg-navy-150': instance.selected }"
								src="./assets/Dots (Blue-Gray).svg"
								role="button" />
						</div>
					</div>
				</div>
			</div>
			<div
				*ngIf="loading && enableLoadingIndicator"
				class="tw-flex tw-justify-center tw-items-center loader-wrapper"
				[ngClass]="{ loader: sessionsEditable }">
				<mat-spinner></mat-spinner>
			</div>
			<div class="up-empty-state" *ngIf="!loading && instances.length === 0">
				<div class="tw-px-10" *ngIf="activity.status === 'archived'">
					This activity was archived on {{ activity.updated_at | date : 'mediumDate'
					}}<span *ngIf="activity.archived_by_name"> by {{ activity.archived_by_name }}</span
					>.
				</div>
				<ng-container *ngIf="activity.status !== 'archived'"
					>No {{ selectedTabIndex === 0 ? 'upcoming' : 'past' }}
					sessions.
				</ng-container>
			</div>
		</div>
	</ng-template>
</div>
<ng-template #deleteInstanceDialogBody>
	<div class="tw-text-gray-500">
		When you delete an activity session, it’s deleted for everyone. This action can’t be undone. Signups and data associated with the session will
		also be deleted.
	</div>
</ng-template>
